export function toCount(value: unknown): number {
  if (value === null || value === undefined) return 0;
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

export function formatCount(value: unknown): string {
  return String(toCount(value));
}

export function formatMoney(value: unknown): string {
  return `${toCount(value).toFixed(2)} €`;
}
